module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "employment",
    class: {
      active: _vm.id === _vm.employeeActive
    },
    on: {
      "click": function($event) {
        _vm.sendValue(_vm.title, _vm.id)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.icon,
      "alt": "",
      "height": "19px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title-name"
  }, [_vm._v(_vm._s(_vm.title))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5515e268","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/shared/EmploymentComponent.vue
// module id = 1223
// module chunks = 3 65